/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmUsageExtract } from "../../funcs/llmUsageExtract.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetExtractUsageRequest$inboundSchema,
};

export const tool$llmUsageExtract: ToolDefinition<typeof args> = {
  name: "llm-usage-extract",
  description: `Get extract usage

Retrieve usage metrics for extract operations.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmUsageExtract(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
